import type { ComponentProps, ReactNode } from "react";
import { Panel } from "../../surfaces/Panel";
import { Statistic } from "../Statistic";

interface StatisticCardProps {
  label: ReactNode;
  /** Render the value in a monospace face — for numeric readouts. */
  mono?: boolean;
  /** How much room the card leaves around its statistic. Default "lg". */
  pad?: ComponentProps<typeof Panel>["pad"];
  /** The value. */
  children: ReactNode;
}

/** A single `Statistic` lifted onto its own small card — the unit repeated across a row of
 *  headline numbers. */
export function StatisticCard({ label, mono = false, pad = "lg", children }: StatisticCardProps) {
  return (
    <Panel pad={pad}>
      <Statistic label={label} mono={mono}>
        {children}
      </Statistic>
    </Panel>
  );
}
